const br = md => {
  let lines = md.match(/[^\r\n]+/g)

  if (lines === null || lines.length <= 0) {
    return md
  }

  for (let i in lines) {
    const line = lines[i]

    if (line.startsWith(" ")) {
      lines[i] = "<br/>" + line.trim()
    }
  }

  return lines.join("\n\r")
}

export { br }
